export const baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.bizminder.co.in' : 'http://14.14.14.14';
export const addressTextAreaFormatValue = (value) => {
  let out = '';
  const lines = value.trim().replace(/\r?\n|\r/g, '||').split('||');
  lines.forEach((entry, index) => {
    const line = entry.trim();
    if (index === lines.length - 1) {
      if (line.charAt(line.length - 1) === ',') out += line.substr(0, line.length - 1);
      else out += line;
    } else if (line.charAt(line.length - 1) === ',') out += `${line} `;
    else out += `${line}, `;
  });

  return out;
};

export const monthsOptions = [
  { name: 'Jan', value: 0 },
  { name: 'Feb', value: 1 },
  { name: 'Mar', value: 2 },
  { name: 'Apr', value: 3 },
  { name: 'May', value: 4 },
  { name: 'June', value: 5 },
  { name: 'July', value: 6 },
  { name: 'Aug', value: 7 },
  { name: 'Sep', value: 8 },
  { name: 'Oct', value: 9 },
  { name: 'Nov', value: 10 },
  { name: 'Dec', value: 11 },
];



// WEBPACK FOOTER //
// ./src/utils/globals.js